<template>
    <section>
        <div class="page_box">
            <!-- 背景图 -->
            <div class="banner_box">
                <img src="../../assets/newActive/banner_zxdt.jpg" alt="海马行">
            </div>
            <!-- 主体 -->
            <div class="news_box">
                <!-- 河南加油站入驻海马行 -->
                <!-- <a href="http://www.up-zx.cn/views/zhumadian.html"> -->
                    <div class="big_ad" @click="goNews4">
                        <div class="ad_img">
                            <img src="../../assets/newActive/dt5.jpg" style="width:100%;" alt="海马行">
                        </div>
                        <div class="ad_intro">
                            <div class="title">加油站营销：价格战已经不是主战场，赢得客户才能赢得未来</div>
                            <div class="author">原创：海马行</div>
                            <div class="time">2019年5月6日</div>
                            <p class="content"><span class="space"></span>近日，国际油价不断上涨，也带动了国内油价7次上涨的趋势，成品油批零差价大幅收窄。一直屡试不爽的价格战如今就像横扫过来的千军万马，让油站身心俱疲：迎战直降，要考虑是否有足够的成本应对持久的残酷；坚持不降，显然是束手无策不作为，后果可想而知。</p>
                            <p class="content"><span class="space"></span> 当然，事情还没有到生存还是毁灭的地步，狭路相逢，盲目的迎战不是勇气，退一步也许海阔天空。究其原因，油站为什么要降价促销，毫无疑问是为了吸引更多的车主来加油，这样才能提升销量实现高收益。</p>
                        </div>
                    </div>
                <!-- </a> -->
                <!-- 动态列表 -->
                <div class="news_list">
                    <div class="part_title">
                        <p>动态列表</p>
                        <span></span>
                    </div>
                    <div class="list_show">
                        <div class="list_item">
                            <div class="img_box">
                                <img src="../../assets/newActive/火币中国列表.png" alt="海马行">
                            </div>
                            <p class="ad_title">思银股份携手火币中国打造<br>“区块链+能源供应链”项目启动会</p>
                            <div class="ad_content">2018年12月17日思银股份与火币中国就"海马能源供应链”达成战略合作，双方将共同推进区块链技术在能源供应链领域的落地应用。</div>
                            <div class="msg_box">
                                <div class="date">12-17</div>
                                <div class="year">2018</div>
                                <div @click="lookMore1" class="more">
                                    <img src="../../assets/newActive/zk.png" alt="海马行">
                                </div>
                            </div>
                        </div>
                        <div class="list_item">
                            <div class="img_box">
                                <img src="../../assets/newActive/庆云签约列表图.png" alt="海马行">
                            </div>
                            <p class="ad_title">庆云县举行成品油交易大数据项目签约仪式</p>
                            <div class="ad_content">11月12日，北京思创银联科技股份有限公司与庆云县政府举行成品油交易大数据项目签约仪式，庆云县县委副书记、县长孙洪昌，副县长张传军，北京思创银联科技股份有限公司董事长于晓军出席。</div>
                            <div class="msg_box">
                                <div class="date">11-12</div>
                                <div class="year">2018</div>
                                <div @click="lookMore2" class="more">
                                    <img src="../../assets/newActive/zk.png" alt="海马行">
                                </div>
                            </div>
                        </div>
                        <div class="list_item">
                            <div class="img_box">
                                <img src="../../assets/newActive/动态3.png" alt="海马行">
                            </div>
                            <p class="ad_title">河北某大型民营加油站入驻海马行</p>
                            <div class="ad_content">2018年11月8日，河北省某大型民营加油站成功入驻海马行。上线第一天，员工们给予了极大的热情，大力度的营销活动吸引了很多车主的关注和使用。</div>
                            <div class="msg_box">
                                <div class="date">11-08</div>
                                <div class="year">2018</div>
                                <div @click="lookMore3" class="more">
                                    <img src="../../assets/newActive/zk.png" alt="海马行">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        lookMore(){
            this.$router.push({path:'http://www.up-zx.cn/views/zhumadian.html'})
        },
        lookMore1(){
            this.$router.push({name:'news1'})
        },
        lookMore2(){
            this.$router.push({name:'news2'})
        },
        lookMore3(){
            this.$router.push({name:'news3'})
        },
        goNews4(){
            this.$router.push({name:'news5'})
        }
    },
}
</script>
<style scoped>
    /* 背景图 */
    .page_box{
        position: relative;
    }
    .banner_box{
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
    .banner_box img{
        vertical-align: bottom;
        width: 100%;
    }
    /* 主体 */
    .news_box{
        width: 1200px;
        margin: 0 auto;
        padding-top: 200px;
    }
    /* 河南加油站入驻海马行 */
    .big_ad{
        width: 1200px;
        height: 445px;
        background: #fff;
        padding: 40px 30px;
        /* overflow: hidden; */
        box-shadow: 0 0 8px 2px #ccc;
    }
    .big_ad .ad_img, .big_ad .ad_intro{
        display: inline-block;
        vertical-align: top;
        /* float: left; */
    }
    .big_ad .ad_img{
        width: 600px;
        margin-right: 20px;
    }
    .big_ad .ad_intro{
        width: 520px;
        font-size: 16px;
        color: #666;
        text-align: left;
    }
    .ad_intro .title{
        font-size: 24px;
        /* height: 42px; */
        line-height: 42px;
        color: #333;
        text-align: center;
        margin-bottom: 12px;
    }
    .ad_intro .space{
        padding-left: 32px;
    }
    .ad_intro .content{
        padding-top: 24px;
    }
    .ad_intro .time, .ad_intro .author{
        text-align: center;
        color: #999;
        height: 28px;
        line-height: 28px;
    }
    /* 动态列表 */
    .news_list .part_title{
        font-size: 30px;
        padding-top: 56px;
        padding-bottom: 46px;
    }
    .news_list .part_title span{
        padding-left: 70px;
        border-top: 2px solid #0094EB;
        font-size: 0;
    }
    .list_show .list_item{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 380px;
        height: 462px;
        border: 1px solid #bbbbbb;
        margin-right: 30px;
        padding: 20px;
        margin-bottom: 36px;
    }
    .list_show .list_item:last-child{
        margin-right: 0;
    }
    .list_item .img_box{
        margin-bottom: 20px;
    }
    .list_item .ad_title{
        font-size: 16px;
        color: #333;
        margin-bottom: 12px;
    }
    .list_item .ad_content{
        font-size: 14px;
        color: #333;
        text-align: left;
    }
    .msg_box{
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 100%;
        padding: 0 20px;
        color: #BBB;
        text-align: left;
    }
    .date{
        font-size: 24px;
    }
    .year{
        font-size: 14px;
    }
    .more{
        position: absolute;
        top: 8px;
        right: 20px;
    }
</style>


